// src/api/reports.js
import api from './axios';

// 신고 생성 API 호출
export const createReport = (report_type, target_id, reason) =>
  api.post(
    '/api/reports/create/',
    {
      report_type,
      target_id,
      reason
    },
    {
      headers: {
        'Content-Type': 'application/json' // ✅ 명시적 JSON 지정
      }
    }
  );
